export enum StatisticsMenuTitleEnum {
  RECOGNITION = 'RECOGNITION',
  APPLICATIONS = 'APPLICATIONS',
  SERVER = 'SERVER',
}
